module.exports = __webpack_public_path__ + "img/mode-edit.e0b48ff9.svg";